import PlanetsController from "./controllers/planets_controller"

window.Stimulus.register("planets", PlanetsController)
